import { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }

    setSubmitting(true);

    const { error: resetError } = await supabase.auth.resetPasswordForEmail(email.trim(), {
      redirectTo: `${window.location.origin}${__BASE_PATH__}/reset-password`,
    });

    setSubmitting(false);

    if (resetError) {
      setError(resetError.message);
    } else {
      setSent(true);
    }
  };

  return (
    <>
      <Navbar />
      <main className="min-h-screen flex items-center justify-center pt-16 pb-12 bg-background-50">
        <div className="w-full max-w-md mx-auto px-4">
          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-8">
            <div className="text-center mb-8">
              <div className="w-12 h-12 mx-auto rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                <i className="ri-key-2-line text-2xl text-accent-600"></i>
              </div>
              <h1 className="font-heading text-2xl font-bold text-foreground-950">Reset Password</h1>
              <p className="text-sm text-foreground-500 mt-1">
                {sent ? 'Check your email for the reset link' : 'Enter your registered email to receive a reset link'}
              </p>
            </div>

            {sent ? (
              <div className="text-center">
                <div className="p-4 rounded-xl bg-accent-100/50 border border-accent-200 mb-6">
                  <p className="text-sm text-accent-800">
                    Password reset link has been sent to <strong>{email}</strong>. Please check your inbox and spam folder.
                  </p>
                </div>
                <Link to="/login" className="text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer">
                  Back to Login
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                {error && (
                  <div className="p-3 rounded-lg bg-red-50 border border-red-200 text-red-600 text-sm">{error}</div>
                )}
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5" htmlFor="reset-email">Registered Email</label>
                  <input
                    id="reset-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-foreground-900 text-sm focus:border-primary-400 focus:ring-1 focus:ring-primary-200 outline-none transition-colors placeholder:text-foreground-400"
                    placeholder="team@example.com"
                    autoComplete="email"
                  />
                </div>
                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full py-2.5 rounded-lg bg-primary-500 hover:bg-primary-600 disabled:bg-primary-400 disabled:cursor-not-allowed text-background-50 dark:text-foreground-950 font-semibold text-sm transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
                >
                  {submitting && <div className="w-4 h-4 rounded-full border-2 border-background-50 border-t-transparent animate-spin"></div>}
                  {submitting ? 'Sending...' : 'Send Reset Link'}
                </button>
                <div className="text-center">
                  <Link to="/login" className="text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer">
                    Back to Login
                  </Link>
                </div>
              </form>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}